import React from 'react';
import { Select, Cascader } from 'antd';

export default ({onChange, value, id, goodsType, defaultValue, ...others}) => {
    const [cates, setCates] = React.useState([]);
    const [currentCateIds, setCurrentCateIds] = React.useState([]);

    React.useEffect(() => {
        getCates().then(res => {
            setCates(res);
        })
    }, [goodsType]);

    React.useEffect(() => {
        if(defaultValue && cates.length > 0) {
            const path = findPathById(cates, defaultValue);
            setCurrentCateIds(path);
        } else {
            setCurrentCateIds(defaultValue ? [defaultValue] : []);
        }
    }, [defaultValue, cates]);

    // 根据ID查找路径的递归函数
    const findPathById = (data, targetId) => {
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (item.value === targetId || item.cateId === targetId) {
                return [item.value || item.cateId];
            }
            
            if (item.children) {
                const childPath = findPathById(item.children, targetId);
                if (childPath.length > 0) {
                    return [item.value || item.cateId, ...childPath];
                }
            }
        }
        return [];
    };

    const onCateChange = (value, selectedOptions) => {
        setCurrentCateIds([value]);

        onChange?.(value, cates);
    };

    const getCates = async () => {
        if(!goodsType) return [];
        
        let response = await fetch('/api/sys-category/tree?goodsType='+goodsType);
        let result = await response.json();

        if(result && result.success) { 
            return result.data;
        }
        return [];
    }

    return (
        // <Select
        //     id={id}
        //     options={cates}
        //     // defaultValue={currentCateIds}
        //     value={currentCateIds}
        //     // expandTrigger="hover"
        //     // displayRender={displayRender}
        //     onChange={onCateChange}
        // />
        <Cascader {...others} options={cates} changeOnSelect value={currentCateIds} onChange={onCateChange} />
    )
}